export default "__VITE_ASSET__CvQCl5eH__"